import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { infoOption } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'corum-gestion-libre-form',
    templateUrl: './corum-gestion-libre-form.component.html',
    styleUrls: ['./corum-gestion-libre-form.component.scss'],
    standalone: false
})
export class CorumGestionLibreFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = infoOption;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.setCommand([
      CommandEnum.FILL_OPERATION_PLEDGE_PRODUCT,
    ]);
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  hasNotFullyCompleted() {
    const corumGestionLibreRepartition = this
      .corumGestionLibreRepartition as UntypedFormArray;

    const percentages = corumGestionLibreRepartition.controls.map(control => {
      return Number(control.get('percentage')?.value || 0);
    });

    const totalPercentage = percentages.reduce((acc, val) => acc + val, 0);

    return totalPercentage !== 100;
  }
}
